import { Directive, ElementRef, Input, Output, EventEmitter, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[md3Menu]',
  standalone: true,
  exportAs: 'md3Menu'
})
export class MD3MenuDirective {
  @Input() md3Menu: string = '';
  @Output() menuOpened = new EventEmitter<void>();
  @Output() menuClosed = new EventEmitter<void>();

  private isOpen = false;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.renderer.addClass(this.elementRef.nativeElement, 'md3-menu');
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
  }

  get menuOpen(): boolean {
    return this.isOpen;
  }

  openMenu(): void {
    if (!this.isOpen) {
      this.isOpen = true;
      this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'block');
      this.renderer.addClass(this.elementRef.nativeElement, 'open');
      this.menuOpened.emit();
    }
  }

  closeMenu(): void {
    if (this.isOpen) {
      this.isOpen = false;
      this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
      this.renderer.removeClass(this.elementRef.nativeElement, 'open');
      this.menuClosed.emit();
    }
  }

  toggleMenu(): void {
    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as Element;
    if (this.isOpen && target && !this.elementRef.nativeElement.contains(target)) {
      const parentButton = target.closest('.user-menu-button, .lang-button');
      if (!parentButton) {
        this.closeMenu();
      }
    }
  }
}

@Directive({
  selector: '[md3MenuTrigger]',
  standalone: true
})
export class MD3MenuTriggerDirective {
  @Input() md3MenuTrigger!: MD3MenuDirective;

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.stopPropagation();
    if (this.md3MenuTrigger) {
      this.md3MenuTrigger.toggleMenu();
    }
  }
}
